import React, { useEffect } from "react";
import { Row, Col, Typography, Space, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import SpinFC from "antd/lib/spin";
import { useQrBooking } from "./hook";

const QrBooking = () => {
  const { loading, listImage, handleDownload, getQrCode } = useQrBooking();

  useEffect(() => {
    getQrCode();
  }, []);

  return (
    <div style={{ width: "100%", padding: 0 }}>
      <Row gutter={32}>
        {listImage.map((item, index) => (
          <Col style={{ borderRight: "1px solid #ccc" }} xs={24} md={12}>
            <Typography.Title
              level={4}
              style={{ margin: 0, textAlign: "center" }}
            >
              {item.title}
            </Typography.Title>
            {item?.url ? (
              <div className="text-center pt-2 pb-5">
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    padding: 24,
                    textAlign: "center",
                  }}
                >
                  <img
                    src={item?.url}
                    alt={item.title}
                    style={{
                      width: "60%",
                      margin: "0 auto",
                      marginBottom: 8,
                    }}
                  />
                </div>
                <Space>
                  <Button
                    className="d-flex align-items-center justify-content-center"
                    onClick={() => handleDownload(item)}
                    icon={<DownloadOutlined />}
                    type="primary"
                  >
                    {item.textDownload}
                  </Button>
                </Space>
              </div>
            ) : (
              <div className="text-center py-5">
                {loading ? (
                  <SpinFC spinning={loading} />
                ) : (
                  <Typography>Chưa có mã QR</Typography>
                )}
              </div>
            )}
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default QrBooking;
